import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get(`/blog/${slug}`)
      .then((r) => mounted && setPost(r.data))
      .catch(() => mounted && setError(true))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, [slug]);

  return (
    <div className="bg-warmwhite text-charcoal min-h-screen" data-testid="blog-post-page">
      <Nav />
      <article className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/#blog" className="inline-flex items-center gap-2 text-sm uppercase tracking-widest-custom text-charcoal/60 hover:text-gold transition-colors mb-12" data-testid="back-to-blog">
            <ArrowLeft className="w-4 h-4" /> Back to journal
          </Link>
          {loading && <p className="text-charcoal/50">Loading…</p>}
          {error && <p className="text-charcoal/50">Article not found.</p>}
          {post && (
            <>
              <p className="text-xs uppercase tracking-widest-custom text-olive mb-4" data-testid="post-category">{post.category}</p>
              <h1 className="font-serif text-4xl md:text-6xl font-light leading-[1.05] tracking-tight mb-8" data-testid="post-title">{post.title}</h1>
              <p className="text-sm text-charcoal/50 mb-10">{new Date(post.published_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })} • {post.author}</p>
              <div className="aspect-[16/9] mb-12 overflow-hidden">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
              </div>
              <div className="font-serif text-xl md:text-2xl leading-relaxed text-charcoal/85 italic mb-8">{post.excerpt}</div>
              <div className="text-base md:text-lg leading-[1.85] text-charcoal/80 whitespace-pre-line">{post.body}</div>
            </>
          )}
        </div>
      </article>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
